export default function ImportBlock({children}){
    return(
        <div className="import-block">
            {children}
        </div>
    )
}